import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCashoutResponse, useNewTransferStore } from 'store'
import PageWrapper from 'components/PageWrapper'
import Card from 'components/Card'
import PrimaryButton from 'components/primaryButton'
import { SuccessIcon } from 'assets/icons'
import { moneyFormat } from 'utils'
import { ListItem } from './ConfirmTransfer'

const CashoutSuccess = () => {
  const navigate = useNavigate()
  const { response } = useCashoutResponse()
  const { updateToDefault } = useNewTransferStore()

  useEffect(() => {
    updateToDefault()
  }, [])

  return (
    <PageWrapper
      hasBackButton={false}
      viewSelected='/movimientos'
      title='Transferencia'
      noTabBar
    >
      <section className='sm:max-w-564 text-black flex flex-col items-center sm:mt-0 mx-auto'>
        <SuccessIcon />
        <h1 className='text-xl font-bold leading-5 my-4'>
          Solicitud de transferencia en proceso
        </h1>
        <p className='font-medium'>
          En unos minutos verás reflejado el movimiento en tu cuenta
        </p>
        <Card className='w-full bg-white py-2 px-4 mt-4'>
          <ul className='w-full text-left divide-y-2 divide-gray-500'>
            <ListItem name='Monto' value={moneyFormat(response.amount)} />
            <ListItem name='Destino' value={response.tax_value} />
            <ListItem
              name='Banco'
              value={
                <span className='flex gap-1'>
                  {!!response.bank_image && (
                    <>
                      <img
                        className='rounded-full h-5 w-5'
                        src={response.bank_image}
                        alt=''
                      />{' '}
                    </>
                  )}
                  {response.bank_name}
                </span>
              }
            />
          </ul>
        </Card>
        <PrimaryButton
          className='mt-8'
          buttonText='Volver al inicio'
          primaryButtonFunction={() => {
            navigate('/transferencias', { replace: true })
          }}
        />
        <PrimaryButton
          outlined
          className='mt-4 mb-8'
          buttonText='Transferir nuevamente'
          primaryButtonFunction={() => {
            navigate('/transferencias/contactos', { replace: true })
          }}
        />
      </section>
    </PageWrapper>
  )
}

export default CashoutSuccess
